<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newStdRiskTxt">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newStdRiskTxt">Create New Standard Risk Text</v-toolbar-title>
          <v-toolbar-title v-else>Edit Standard Risk Text</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn v-if="!newStdRiskTxt" color="primary" @click="goToStdRiskItemTxt()">
            Standard Item Text
            <v-icon right>mdi-view-list</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="newStdRiskTxt">
                <v-text-field
                  v-model="stdRiskTxtForm.stdRiskTxtRef"
                  :label="labels.stdRiskTxtRef"
                  :error-messages="errors.collect('stdRiskTxtRef')"
                  data-vv-name="stdRiskTxtRef"
                  :data-vv-as="labels.stdRiskTxtRef"
                  v-validate="'required|param|max:3'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{ labels.stdRiskTxtRef }}</v-subheader>
                <div class="queryValue">{{ stdRiskTxtForm.stdRiskTxtRef }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-textarea
                  auto-grow
                  rows="1"
                  filled
                  v-model="stdRiskTxtForm.stdRiskTxtLn"
                  :label="labels.stdRiskTxtLn"
                  :error-messages="errors.collect('stdRiskTxtLn')"
                  data-vv-name="stdRiskTxtLn"
                  :data-vv-as="labels.stdRiskTxtLn"
                  v-validate="'required|entry|max:1000'"
                ></v-textarea>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6>
                <v-textarea
                  auto-grow
                  rows="1"
                  filled
                  v-model="stdRiskTxtForm.stdRiskDetLn"
                  :label="labels.stdRiskDetLn"
                  :error-messages="errors.collect('stdRiskDetLn')"
                  data-vv-name="stdRiskDetLn"
                  :data-vv-as="labels.stdRiskDetLn"
                  v-validate="'max:8000'"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdName }}</v-subheader>
                <div class="queryValue">{{ stdRiskTxtForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(stdRiskTxtForm.createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newStdRiskTxt">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedName }}</v-subheader>
                <div class="queryValue">{{ stdRiskTxtForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(stdRiskTxtForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions v-if="!loading">
          <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
            <span>Cancel</span>
            <v-icon right dark>mdi-cancel</v-icon>
          </v-btn>
          <v-btn color="primary" dark @click="doSave" :loading="submitting">
            {{ newStdRiskTxt ? 'Save Standard Risk Text' : 'Save Standard Risk Text' }}
            <v-icon right> {{ newStdRiskTxt ? 'mdi-content-save' : 'mdi-content-save' }} </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      labels: {
        stdRiskTxtRef: 'Standard Risk Text Ref*',
        stdRiskTxtLn: 'Standard Risk Text Line*',
        stdRiskDetLn: 'Standard Risk Detail Line',
        createdBy: 'Created By',
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      stdRiskTxtForm: {
        stdRiskTxtRef: null,
        stdRiskTxtLn: null,
        stdRiskDetLn: null,
        createdBy: null,
        createdDate: new Date(),
        modifiedBy: null,
        modifiedDate: null,
        createdName: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
        modifiedName: null
      },
      newStdRiskTxt: false,
      loading: false,
      submitting: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.stdRiskTxtRefMenu.getStdRiskTxt
      if (apiURI) {
        this.loading = true
        try {
          const expand = { stdrisktxt: this.stdrisktxt }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.stdRiskTxtForm.stdRiskTxtRef = data.stdRiskTxt.stdRiskTxtRef
            this.stdRiskTxtForm.stdRiskTxtLn = data.stdRiskTxt.stdRiskTxtLn
            this.stdRiskTxtForm.stdRiskDetLn = data.stdRiskTxt.stdRiskDetLn
            this.stdRiskTxtForm.createdName = data.stdRiskTxt.createdName
            this.stdRiskTxtForm.createdDate = data.stdRiskTxt.createdDate
            this.stdRiskTxtForm.modifiedName = data.stdRiskTxt.modifiedName
            this.stdRiskTxtForm.modifiedDate = data.stdRiskTxt.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newStdRiskTxt) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        }
      })
    },
    async doCreate() {
      const apiURI = this.stdRiskTxtRefMenu.createStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.stdRiskTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.goToStdRiskItemTxt()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.stdRiskTxtRefMenu.updateStdRiskTxt
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.stdRiskTxtForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.goToStdRiskItemTxt()
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.submitting = false
      }
    },
    async goToStdRiskItemTxt(stditemtxt, stdriskln) {
      this.$router.push({
        name: 'stdItemTxtList',
        params: { stditemtxt: this.stdRiskTxtForm.stdRiskTxtRef, stdriskln: this.stdRiskTxtForm.stdRiskTxtLn }
      })
    },
    doCancel() {
      this.$router.push({ name: 'stdRiskTxtList' })
    }
  },
  computed: {
    stdRiskTxtRefMenu() {
      return this.$store.state.StdRiskTxtParam.menu
    },
    stdrisktxt() {
      return this.$route.params.stdrisktxt
    }
  },
  created() {
    if (this.stdrisktxt === 'new') {
      this.newStdRiskTxt = true
    } else {
      this.doFetch()
    }
  },
  mixins: [MessageMixin]
}
</script>
